<template>
  <div class="bg-cream-deep tc py-48 br-14 px-30 mb-py-30 mb-mb-60">
    <h2
      class="fs-36 lh-1 fw-900 mb-fs-28 mb-mb-20 mb-30"
    >
      {{ title }}
    </h2>
    <div class="description mb-20 wp-100 maxw-570 ma-0-auto">
      <Readmore :text="displayedText" :custom-font-classes="'di lh-22'" :url="url" :text-max="30"/>
    </div>
    <ul class="fs-12 lh-15 fw-700 mb-30">
      <li v-for="(link, i) in quickLinks" :key="i" class="mb-12">
        <router-link :to="{ path: url, hash: `#${link.url}` }" class="lh-14"
        ><span class="dib mr-8"
        ><img :src="`${$assetsCdn}/icons/icon-link.svg`" alt="icon-link"/></span
        >{{ link.title }}</router-link>
      </li>
    </ul>
    <div>
      <router-link
        :to="url"
        class="button button-primary ml-15 mr-15 ttc"
        :title="`Read Our ${capitalize(urlTitle)} Travel Guide`"
        :aria-label="`Read Our ${capitalize(urlTitle)} Travel Guide`"
      >Read More About {{ capitalize(countryName) }}</router-link
      >
<!--      <a
          :href="url"
          class="button button-primary ml-15 mr-15 ttc"
          :title="`Read Our ${capitalize(urlTitle)} Travel Guide`"
          :aria-label="`Read Our ${capitalize(urlTitle)} Travel Guide`"
      >Read More About {{ capitalize(countryName) }}</a>-->
    </div>
  </div>
</template>
<script>
import { computed } from 'vue'
import { capitalize } from '~/helper'
import Readmore from './Readmore'
export default {
  components: {
    Readmore,
  },
  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
    description: {
      type: String,
      default: '',
      required: true,
    },
    quickLinks: {
      type: Array,
      default: null,
      required: true,
    },
    url: {
      type: String,
      default: '',
      required: true,
    },
    urlTitle: {
      type: String,
      default: '',
      required: true,
    },
    countryName : {
      type: String,
      default: '',
      required: true,
    }
  },
  setup(props) {
    const displayedText = computed(() => {
      if(process.server) return props.description.replace(/<[^>]*>?/gm, '');
      // Remove html tag
      let div = document.createElement("div")
      div.innerHTML = props.description
      return `${div.innerText.split(' ').slice(0, 50).join(' ')}`
    })


    return {
      displayedText,
      capitalize,
    }
  },
}
</script>
<style lang="scss" scoped>
ul {
  li {
    a {
      color: $link; // v2 §Text Links — sidebar links are green (was #000)
      display: inline-block;
    }
  }
}

:deep(.customCSS) {
  p {
    display: inline;
  }
}

.btn-read{
  color: $link; // v2 — green Link, underline on hover only (was black + resting underline)
  &:hover { text-decoration: underline; }
}

.description {
  font-size: 18px;
  line-height: 22px;
  :deep(p) {
    margin-bottom: 20px;
    font-size: 18px;
    line-height: 22px;
  }
}
@include phone {
  .description {
    font-size: 16px; // §8 body floor — was 14px
    line-height: 22px;
    :deep(p) {
      font-size: 16px;
      line-height: 22px;
    }
  }
}
</style>
